// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"38c2a588","38":"bd6c90d4","239":"18dd622a","455":"cb59dbed","977":"73046a36"}[chunkId] + ".chunk.js";
};